<script setup>
import {onMounted, reactive, ref, nextTick, computed, watch} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import YTActivityState from "@/components/YTActivitySaleState/index.vue"
import moment from "moment";
import YTTagGroup from "@/components/YTTagGroup/index.vue"
import {
  activity_album_saveAdmin, api_cancelCollectActivityPhotoAdmin, api_collectActivityPhotoAdmin,
  changeActivityStateAdmin, detailActivityAdmin,
  listActivityAdmin,
  listClubMerchandiseOrder, downloadMerchandiseOrder, updateMerchandiseOrder,
  api_getAlbumAdmin, listActivityParticipantAdmin,
} from "@/api/club/club.js";
import axios from 'axios';
import {userInfoStore, userTokenStore} from "@/store/store.js";
import {certificateTypeEnum} from "@/enum/certificateTypeEnum.js";
import YTAddress from "@/components/YTAddress/index.vue";
import {activityEnum} from "@/enum/activityEnum.js";
import {merchandiseOrderEnum} from "@/enum/merchandiseOrderEnum.js";
import {vipLevelEnum} from "@/enum/vipLevelEnum.js";
import {editActivityStateAdmin} from "@/api/virtualGoods/virtualGoods.js";
import {setActivityTop} from "@/api/club/club.js";
import router from "@/router/index.js";
import YTRadio from "@/components/YTRadio/index.vue";
import {shortNumberFormat} from "@/hooks/numberUtils.js";
import {debounceFn} from "@/hooks/debounce.js";
import YTActivitySignOrderState from "@/components/YTActivitySignOrderState/index.vue";
import YTOrderState from "@/components/YTOrderState/index.vue";
import {listGoodsIgnoreTenant} from "@/api/goods/goods.js";
import BoxUpload from "@/components/YTBoxUpload/newIndexNewApi.vue";
import YTTab from "@/components/YTTab/index.vue";
import YTGender from "@/components/YTGender/index.vue";
import YTDialog from "@/components/YTDialog/index.vue";
import { Close } from "@element-plus/icons-vue";

/*初次加载*/
onMounted(async () => {
  await handleGetStoreGroups()
  await handleSearch()
})

const cancel_albumImageIndex = ref(0);
const cancel_collect_show = ref(false);

const tabs_list = reactive([
  {
    id: 0,
    title: "报名人员信息",
    show: true,
  },
  {
    id: 1,
    title: "活动介绍",
    show: true,
  },
  {
    id: 2,
    title: "活动相册",
    show: true,
  },
]);
const tab_selected = ref(0);

// 用户信息
const userInfo = userInfoStore().info

/*搜索功能*/
// 表单数据
const formData = reactive({
  queryType: null,
  activityName: null,
  cityCode: null,
  groupId: null,
  activityTime: [],
  startTime: null,
  endTime: null,
  creationTime: [],
  creationStartTime: null,
  creationEndTime: null,
  activityState: null
});
// 表单锚点
const ruleFormRef = ref()
// 切换搜索类型
const handleChangeQueryType = (type) => {
  formData.queryType = type
  handleSearch()
}
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    // 处理时间
    formData.startTime = formData.activityTime[0] ? moment(formData.activityTime[0]).startOf('day').format("YYYY-MM-DD HH:mm:ss") : null;
    formData.endTime = formData.activityTime[1] ? moment(formData.activityTime[1]).endOf('day').format("YYYY-MM-DD HH:mm:ss") : null;
    formData.creationStartTime = formData.creationTime[0] ? moment(formData.creationTime[0]).startOf('day').format("YYYY-MM-DD HH:mm:ss") : null;
    formData.creationEndTime = formData.creationTime[1] ? moment(formData.creationTime[1]).endOf('day').format("YYYY-MM-DD HH:mm:ss") : null;
    // 搜索实物商品
    const res = await listActivityAdmin(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    console.log("tableData", tableData.value)
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 城市选择组件锚点
const YTAddressRef = ref()
// 清空表单内容
const handleReset = () => {
  formData.activityName = null
  formData.cityCode = null
  formData.groupId = null
  formData.activityTime = []
  formData.startTime = null
  formData.endTime = null
  formData.creationTime = []
  formData.creationStartTime = null
  formData.creationEndTime = null
  formData.activityState = null
  handleSearch('btnSearch')
  YTAddressRef.value.cleanSelect()
}
// 活动分组选项
const storeGroupsOption = ref([]);
// 获取活动分组
const handleGetStoreGroups = async () => {
  try {
    loading.value = true;
    const res = await listClubCategory({ page: 1, pageSize: 100 });
    storeGroupsOption.value = res.list;
    loading.value = false;
  } catch (e) {
    loading.value = false;
  }
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
const selected_act_id = ref(null);
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '活动名称', key: 'goodsName', maxWidth: '250px', nowrap: true },
  { title: '发布时间', key: 'crTime', nowrap: true },
  { title: '活动时间', key: 'activityTime', nowrap: true },
  { title: '活动城市', key: 'city', width: '200px', nowrap: true },
  { title: '归属商家', key: 'storeName', nowrap: true },
  { title: '分组', key: 'storeGroupList', nowrap: false },
  { title: '标签', key: 'tagList', nowrap: false },
  { title: '活动状态', key: 'activityState', nowrap: true },
  { title: '已报名', key: 'inventory', nowrap: true },
  { title: '费用', key: 'retailPrice', nowrap: true },
  { title: '发布状态', key: 'state', nowrap: true },
  { title: '操作', key: 'controls', width: "120px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 发布
const setSale = async (item) => {
  const param = {
    goodsId: item.goodsId,
    state: 1
  }
  try {
    await changeActivityStateAdmin(param)
    ElMessage.success("发布成功")
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}
// 打开判断下架方式面板
const handleOpenUnSalePanel = (item) => {
  cacheUnSaleInfo.value = item
  open.value = true
}
// 打开下架方式面板
const open = ref(false)
// 缓存信息
const cacheUnSaleInfo = ref()
// 下架类型
const unSaleType = ref(1) // 0: 强制下架 1: 正常下架
// 处理下架面板关闭
const handleClosePanel = () => {
  open.value = false
  cacheUnSaleInfo.value = null
  unSaleType.value = 1
}
// 处理下架面板确认
const handleUnSaleConfirm = async () => {
  if (unSaleType.value === 1) {
    await setUnSale(cacheUnSaleInfo.value)
    handleClosePanel()
  } else if (unSaleType.value === 0) {
    await setForceUnSale(cacheUnSaleInfo.value)
    handleClosePanel()
  }
}
// 下架
const setUnSale = async (item) => {
  const param = {
    goodsId: item.goodsId,
    state: 0
  }
  try {
    await changeActivityStateAdmin(param)
    ElMessage.success("下架成功")
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}
// 强制下架
const setForceUnSale = async (item) => {
  const param = {
    goodsId: item.goodsId,
    state: -1
  }
  try {
    await changeActivityStateAdmin(param)
    ElMessage.success("下架成功")
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}
// 置顶活动/取消置顶活动
const setTop = async (item, type) => {
  try {
    loading.value = true
    console.log("item.goodsId", item.goodsId)
    await setActivityTop(item.goodsId, {isTop: type})
    ElMessage.success(`活动${type ? '' : '取消'}置顶成功`)
    await handleSearch()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 编辑活动
const handleToEdit = (item) => {
  router.push({ path: '/addActivity', query: { goodsId: item.goodsId } })
}

// 获取活动详情
const getDetail = async (item) => {
  try {
    console.log("item", item)
    selected_act_id.value = item.goodsId;
    drawer.value = true
    drawerLoading.value = true
    drawerCache.value = await detailActivityAdmin(item.goodsId)
    if (drawerCache.value?.description) {
      drawerCache.value.description = drawerCache.value.description.replace(
          /<img[^>]*>/g,
          (match) =>
              match.replace(
                  />$/,
                  ' style="width:100%;height:auto;object-fit:contain;" />'
              )
      );
    }
    if (drawerCache.value?.descriptionEn) {
      drawerCache.value.descriptionEn = drawerCache.value.descriptionEn.replace(
          /<img[^>]*>/g,
          (match) =>
              match.replace(
                  />$/,
                  ' style="width:100%;height:auto;object-fit:contain;" />'
              )
      );
    }
    activityState.value = drawerCache.value.activityInfo.activityState
    // 同步相册查询所需的goodsId，并重置分页为第一页
    album_params.query_params.goodsId = item.goodsId;
    albumPaginationRef.value?.resetPage();
    album_params.page_params.pageNum = 1;
    tabs_list[2].show = drawerCache.value.activityInfo.hasAlbum;
    drawerLoading.value = false
    nextTick(async () => {
      await handleGetParticipantList();
      await getAlbum();
    });
  } catch (e) {
    console.log(e)
    drawerLoading.value = false
  }
}

// 表格加载状态
const drawerTableLoading = ref(false)
// 处理获取活动详情报名人员列表
const handleGetParticipantList = async () => {
  // 组件弹出需要时间，所以使用nextTick
  await nextTick(async () => {
    try {
      drawerTableLoading.value = true
      let pageInfo = {
        page: YTTablePaginationDrawerRef.value.getPage(),
        pageSize: YTTablePaginationDrawerRef.value.getPageSize()
      }
      let param = {
        goodsId: drawerCache.value.goodsId,
      }
      const res = await listActivityParticipantAdmin(pageInfo, param)
      console.log("res", res.list)
      drawerTableData.value = []
      setTimeout(() => {
        drawerTableData.value = res.list
        totalDrawer.value = parseInt(res.total)
        drawerTableLoading.value = false
      }, 0)
    } catch (e) {
      console.log(e)
      drawerTableLoading.value = false
    }
  })
}

// 右弹出抽屉打开状态
const drawer = ref(false)
// 右弹出抽屉加载状态
const drawerLoading = ref(false)
// 处理右弹出抽屉关闭
const handleCloseDrawer = () => {
  console.log("run in handleCloseDrawer")
  YTTablePaginationDrawerRef.value.resetPage()
  drawerCache.value = {
    goodsName: null
  }
  drawer.value = false
  activityState.value = null
}
// 处理右弹出抽屉翻页
const handleDrawerPageChange = () => {
  handleGetParticipantList();
};
// 证件类型枚举
const certificateType = ref(certificateTypeEnum)

// 右弹出抽屉表格表头
const drawerHeaders = ref([
  { title: '序号', key: 'index', maxWidth: '100px', nowrap: true },
  { title: '是否签到', key: 'hasCheckIn', nowrap: true },
  { title: '姓名', key: 'personInfo.name', nowrap: true },
  { title: '性别', key: 'personInfo.gender', nowrap: true },
  { title: '手机号', key: 'personInfo.phone', nowrap: true },
  { title: '证件类型', key: 'personInfo.certificateType', nowrap: true },
  { title: '证件号码', key: 'personInfo.certificateNumber', width: "200px", nowrap: true },
  { title: '所选俱乐部', key: 'storeName', nowrap: true },
  { title: '紧急联系人', key: 'personInfo.emergencyContact', minWidth: "150px", nowrap: true },
  { title: '紧急联系人电话', key: 'personInfo.emergencyContactPhone', minWidth: "180px", nowrap: true },
  { title: '备注', key: 'remark', minWidth: "180px", maxWidth: "250px" },
  { title: '报名状态', key: 'orderState', minWidth: "120px", fixed: true },
])
// 右弹出抽屉表格数据
const drawerTableData = ref([])
// 右弹出抽屉缓存信息
const drawerCache = ref({
  goodsName: null,
  goodsId: null
})
// 右弹出抽屉列表翻页锚点
const YTTablePaginationDrawerRef = ref()
// 右弹出抽屉列表总数
const totalDrawer = ref(0)
// 已选中的报名状态Id
const selectedIds = ref([]);
// 监听已选中的报名状态Id
watch(
    selectedIds,
    (newVal) => {
      handleSignStateChange([...newVal]);
    },
    { deep: true }
);
// 处理弹窗表头选择报名状态过滤条件
const handleSelectSignStateFilter = (item) => {
  const index = selectedIds.value.findIndex((i) => i === item.stateId);
  console.log("index", index);
  if (index === -1) {
    selectedIds.value.push(item.stateId);
  } else {
    selectedIds.value.splice(index, 1);
  }
};
// 处理下载活动报名人员名单
const handleDownloadActivityUser = async (item) => {
  ElMessage.warning("下载中...")
  if (drawerCache.value.hasActivityRegisterExtraInfo) {
    await downloadFile(
        `${
            import.meta.env.VITE_API_URL
        }/activity/management/download/participant/extraInfo?activityId=${item.goodsId}`,
        {}, // 请求体数据
        `${item.goodsName}报名人员名单-${moment().format(
            "YYYY-MM-DD_HHmmss"
        )}.csv` // 默认文件名
    );
  } else {
    await downloadFile(
        `${import.meta.env.VITE_API_URL}/activity/management/download/participant?activityId=${item.goodsId}`,
        {}, // 请求体数据
        `${item.goodsName}报名人员名单-${moment().format("YYYY-MM-DD_HHmmss")}.csv` // 默认文件名
    );
  }
}
// 处理下载活动已报名人员名单
const handleDownloadSignedUpActivityUser = async (item) => {
  ElMessage.warning("下载中...")
  if (drawerCache.value.hasActivityRegisterExtraInfo) {
    await downloadFile(
        `${
            import.meta.env.VITE_API_URL
        }/activity/management/download/participant/extraInfo?activityId=${
            item.goodsId
        }&orderState=REGISTERED`,
        {}, // 请求体数据
        `${item.goodsName}已报名人员名单-${moment().format(
            "YYYY-MM-DD_HHmmss"
        )}.csv` // 默认文件名
    );
  } else {
    await downloadFile(
        `${
            import.meta.env.VITE_API_URL
        }/activity/management/download/participant?activityId=${
            item.goodsId
        }&orderState=REGISTERED`,
        {}, // 请求体数据
        `${item.goodsName}已报名人员名单-${moment().format(
            "YYYY-MM-DD_HHmmss"
        )}.csv` // 默认文件名
    );
  }
}
/**
 * 自定义文件名的下载函数
 * @param {string} url - 完整接口URL
 * @param {Object} requestData - 请求体数据
 * @param {string} customFilename - 自定义文件名
 */
const downloadFile = async (url, requestData = {}, customFilename) => {
  try {
    const token = userTokenStore().token
    const response = await axios.post(
        url,
        requestData,
        {
          responseType: 'blob',
          headers: {
            'Authorization': token.tokenValue,
            'Login-Type': token.loginType,
            'Content-Type': 'application/json',
          },
          validateStatus: (status) => {
            if (status === 409) {
              ElMessage.error("数据列表为空,暂无数据导出")
              return false
            }
            return true
          },
        }
    );

    // 创建下载链接
    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', customFilename); // 使用传入的自定义文件名
    document.body.appendChild(link);
    link.click();

    // 清理
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);

    return true;
  } catch (error) {
    console.error('文件下载失败:', error);
    ElMessage.error('文件下载失败');
    return false;
  }
};

// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data)
  formData.cityCode = data.value[data.label.length - 1]
  console.log("formData.cityCode", formData.cityCode)
}

// 活动状态
const activityState = ref()

// 活动状态枚举
const activityStateOption = ref(activityEnum)

// 处理活动状态改变
const handleChangeState = async (state) => {
  console.log("state", state)
  await ElMessageBox.confirm(
    '确定修改活动状态?',
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(async () => {
      console.log("确定修改活动状态，即将发起接口")
      activityState.value = state
      let param = {
        goodsId: drawerCache.value.goodsId,
        activityState: activityState.value
      }
      console.log("param", param)
      await editActivityStateAdmin(param)
      await getDetail({goodsId: param.goodsId})
      ElMessage({
        type: 'success',
        message: '修改成功',
      })
    })
    .catch(async () => {
      console.log("取消修改活动状态")
      await getDetail({goodsId: drawerCache.value.goodsId})
      ElMessage({
        type: 'info',
        message: '取消修改',
      })
    })
}

// 处理公开返回枚举转换文本
const handleVisibilityType = (type) => {
  let res = "未知状态";
  if (type === "PUBLIC") {
    res = "公开";
  } else if (type === "MEMBER_VISIBLE") {
    res = "会员可见";
  } else if (type === "SPECIFIED_USER") {
    res = "指定用户可见";
  }
  return res;
};

// 处理分组统计已报名人数
const totalLimit = computed(() => {
  const list = drawerCache.value?.activityInfo?.activityDivisions || []

  return list.reduce((total, item) => {
    return total + Number(item.registeredCount || 0)
  }, 0)
})

// 处理分组统计报名上限人数
const maxLimit = computed(() => {
  const list = drawerCache.value?.activityInfo?.activityDivisions || []

  return list.reduce((total, item) => {
    return total + Number(item.quotaLimit || 0)
  }, 0)
})

// 相册功能 ===========================
const album_loading = ref(false);
// 照片预览
const dialogVisible = ref(false);
const dialogImageUrl = ref("");
// 照片编辑
const img_edit = ref(false);
const albumDraft = ref([]);
// 保存原始状态，用于取消编辑时恢复
const originalAlbumImages = ref([]);
const originalAlbumImageInfos = ref([]);
// 照片收藏
const img_collect = ref([]);
const album_list = reactive([]);
const album_params = reactive({
  page_params: {
    pageNum: 1,
    pageSize: 54,
  },
  query_params: {
    goodsId: null,
    storeId: null,
  },
});
const album_total = ref(0);
const albumPaginationRef = ref();
// 获取当前页某一项的图片信息（含收藏状态等）
const getAlbumImageInfo = (item) => {
  // 如果 item 是对象，直接返回；如果是字符串，则查找匹配的项
  if (typeof item === "object" && item !== null) {
    return item;
  }
  return (
      album_list.find((albumItem) => albumItem.originAlbumImage === item) || {}
  );
};
// 获取相册照片
const getAlbum = async () => {
  try {
    album_loading.value = true;
    console.log("drawerCache.value", drawerCache.value)
    album_params.query_params.goodsId = drawerCache.value.goodsId
    album_params.query_params.storeId = drawerCache.value.storeId
    const res = await api_getAlbumAdmin(
        album_params.page_params,
        album_params.query_params
    );
    res.list.map((item) => {
      item.thumbnailAlbumImage_20 = `${item.originAlbumImage}?x-oss-process=image/resize,p_20`;
    });
    album_list.length = 0; // 清空数组
    album_list.push(...res.list); // 添加新元素
    album_total.value = Number(res.total) || 0; // 设置总数
    album_loading.value = false;
  } catch (error) {
    console.log("getAlbum error: ", error);
    album_loading.value = false;
  }
};
// 相册列表分页事件处理
const handleAlbumPageChange = () => {
  album_params.page_params.pageNum = albumPaginationRef.value.getPage();
  album_params.page_params.pageSize = albumPaginationRef.value.getPageSize();
  getAlbum();
};

// 上传失败
const handlePicFail = () => {
  album_loading.value = false;
};
// 上传中
const handlePicProgress = () => {
  album_loading.value = true;
};
// 上传成功
const handlePicSuccess = async (photo_arr) => {
  try {
    const album_list = [
      ...(drawerCache.value.activityInfo.albumImages || []),
      ...photo_arr,
    ];
    const body_params = ref({
      goodsId: selected_act_id.value,
      albumImages: album_list,
    });
    await activity_album_saveAdmin(body_params.value);
    const res2 = await detailActivityAdmin(selected_act_id.value);
    drawerCache.value = res2;
    album_loading.value = false;

    // 重新获取当前页数据以显示新上传的照片
    getAlbum();
  } catch (err) {
    console.log(err);
    album_loading.value = false;
  }
};

const showPreview = (item) => {
  dialogImageUrl.value = item.originAlbumImage;
  dialogVisible.value = true;
};

const startAlbumEdit = () => {
  img_edit.value = true;
  // 保存原始状态，用于取消编辑时恢复
  originalAlbumImages.value = [
    ...(drawerCache.value.activityInfo.albumImages || []),
  ];
  originalAlbumImageInfos.value = [
    ...(drawerCache.value.activityInfo.albumImageInfos || []),
  ];

  // 设置编辑草稿 - 只使用当前页的图片数据
  albumDraft.value = [...album_list];
};

const cancel_finishAlbum = () => {
  // 取消编辑时，还原图片列表和收藏状态为原始状态
  drawerCache.value.activityInfo.albumImages = [...originalAlbumImages.value];
  drawerCache.value.activityInfo.albumImageInfos = [
    ...originalAlbumImageInfos.value,
  ];
  img_edit.value = false;

  // 重新获取当前页数据以显示原始状态
  getAlbum();
};

const deleteAlbumImage = (item) => {
  // 找到要删除的图片在 albumDraft 中的索引
  // 现在 albumDraft 包含完整的图片对象，需要比较 originAlbumImage 属性
  const index = albumDraft.value.findIndex(
      (draftItem) => draftItem.originAlbumImage === item.originAlbumImage
  );
  if (index !== -1) {
    // 删除图片的同时也需要删除对应的收藏状态信息
    albumDraft.value.splice(index, 1);

    // 同步更新albumImageInfos，确保收藏状态与图片一一对应
    if (drawerCache.value.activityInfo.albumImageInfos) {
      drawerCache.value.activityInfo.albumImageInfos.splice(index, 1);
    }
  }
};

const isSameArrayIgnoreOrder = (a = [], b = []) => {
  if (a.length !== b.length) return false;
  const ma = new Map(),
      mb = new Map();
  for (const x of a) ma.set(x, (ma.get(x) || 0) + 1);
  for (const x of b) mb.set(x, (mb.get(x) || 0) + 1);
  if (ma.size !== mb.size) return false;
  for (const [k, v] of ma) if (mb.get(k) !== v) return false;
  return true;
};

const finishAlbum = async () => {
  try {
    album_loading.value = true;

    // 获取当前页的图片ID和URL的映射关系
    const currentPageImageMap = new Map(
        album_list.map((item) => [item.originAlbumImage, item.albumImageId])
    );

    // 获取当前页编辑后的图片URL数组
    const currentPageDraftUrls = albumDraft.value.map(
        (item) => item.originAlbumImage || item
    );

    // 获取完整的相册数据
    let allAlbumImages = [
      ...(drawerCache.value.activityInfo.albumImages || []),
    ];

    // 创建一个新的数组来存储更新后的图片
    const updatedAllImages = allAlbumImages.filter((imageUrl) => {
      // 如果图片URL在当前页面中，则根据编辑后的内容决定是否保留
      if (currentPageImageMap.has(imageUrl)) {
        return currentPageDraftUrls.includes(imageUrl);
      }
      // 不在当前页面的图片保持不变
      return true;
    });

    // 添加新上传的图片（当前页中原来不存在的图片）
    const newImages = currentPageDraftUrls.filter(
        (imageUrl) => !currentPageImageMap.has(imageUrl)
    );
    updatedAllImages.push(...newImages);

    // 检查是否有实际的变化
    const hasChanges = !isSameArrayIgnoreOrder(
        allAlbumImages,
        updatedAllImages
    );

    if (!hasChanges) {
      img_edit.value = false;
      album_loading.value = false;
      return;
    }

    // 保存完整的相册数据
    await activity_album_saveAdmin({
      goodsId: selected_act_id.value,
      albumImages: updatedAllImages,
    });

    // 更新缓存
    drawerCache.value.activityInfo.albumImages = updatedAllImages;
    img_edit.value = false;
    ElMessage.success("已保存");
    album_loading.value = false;

    // 重新获取当前页数据以显示最新状态
    getAlbum();
  } catch (err) {
    console.log(err);
    img_edit.value = false;
    album_loading.value = false;
    ElMessage.error("保存失败");
  }
};

const selectTab = (id) => {
  tab_selected.value = id;
};

// 收藏相片
const collectAlbum = async (item) => {
  try {
    if (img_edit.value) {
      ElMessage.error("请先取消编辑");
      return;
    }
    album_loading.value = true;

    // 找到当前项在 album_list 中的索引
    const albumIndex = album_list.findIndex(
        (albumItem) => albumItem.originAlbumImage === item.originAlbumImage
    );
    if (albumIndex === -1) {
      album_loading.value = false;
      return;
    }

    // 更新本地状态
    album_list[albumIndex].isClubCollected = true;

    await api_collectActivityPhotoAdmin({
      albumImageId: album_list[albumIndex].albumImageId,
      storeId: drawerCache.value.storeId,
      collectionType: "STORE",
    });

    album_loading.value = false;
    ElMessage.success("已收藏");
  } catch (err) {
    console.log(err);
    ElMessage.error("收藏失败");

    // 失败时回滚状态
    const albumIndex = album_list.findIndex(
        (albumItem) => albumItem.originAlbumImage === item.originAlbumImage
    );
    if (albumIndex !== -1) {
      album_list[albumIndex].isClubCollected = false;
    }

    album_loading.value = false;
  }
};

const showCCDialog = async (item) => {
  cancel_albumImageIndex.value = item;
  cancel_collect_show.value = true;
};

// 取消收藏相片
const cancelCollectAlbum = async (index) => {
  try {
    if (img_edit.value) {
      ElMessage.error("请先取消编辑");
      return;
    }
    cancel_collect_show.value = false;
    album_loading.value = true;

    // 找到当前项在 album_list 中的索引
    const albumIndex = album_list.findIndex(
        (albumItem) =>
            albumItem.originAlbumImage ===
            cancel_albumImageIndex.value.originAlbumImage
    );
    if (albumIndex === -1) {
      album_loading.value = false;
      return;
    }

    // 更新本地状态
    album_list[albumIndex].isClubCollected = false;

    await api_cancelCollectActivityPhotoAdmin({
      albumImageId: album_list[albumIndex].albumImageId,
      storeId: drawerCache.value.storeId,
    });
    album_loading.value = false;
    ElMessage.success("已取消收藏");
  } catch (err) {
    console.log(err);
    cancel_collect_show.value = false;
    ElMessage.error("取消收藏失败");

    // 失败时回滚状态
    const albumIndex = album_list.findIndex(
        (albumItem) =>
            albumItem.originAlbumImage ===
            cancel_albumImageIndex.value.originAlbumImage
    );
    if (albumIndex !== -1) {
      album_list[albumIndex].isClubCollected = true;
    }

    album_loading.value = false;
  }
};

// 处理合作身份展示
const handleOrganizeType = (type) => {
  // 1.门店、2.网店、3.俱乐部、4.场地、5.车店、6.理疗师、7摄影师"
  let res = null
  switch (Number(type)) {
    case 1:
      res = "门店"
      break
    case 2:
      res = "网店"
      break
    case 3:
      res = "俱乐部"
      break
    case 4:
      res = "场地"
      break
    case 5:
      res = "车店"
      break
    case 6:
      res = "理疗师"
      break
    case 7:
      res = "摄影师"
      break
    default:
      res = "未知"
      break
  }
  return res
}

/*周边订单drawer*/
const merchandiseOrderDrawerList = ref([])
const merchandiseOrderDrawer = ref(false)
const merchandiseOrderDrawerTotal = ref(0)
const merchandiseOrderDrawerCache = ref({})
const merchandiseOrderDrawerLoading = ref(false)
const merchandiseOrderDrawerFormRef = ref(null)
const merchandiseOrderDrawerForm = ref({
  userId: null,
  orderNo: '',
  nickname: '',
  phone: '',
  paymentTimeRange: [],
  paymentStartTime: '',
  paymentEndTime: '',
  goodsId: '',
  orderState: '',
})
const merchandiseOrderDrawerPaginationRef = ref(null)
const merchandiseOrderDrawerSpanArr = ref([])
const merchandiseOrderDrawerGoodsList = ref([])
const merchandiseOrderDrawerGoodsLoading = ref(false)
const merchandiseOrderDrawerGoodsPage = ref(1)
const merchandiseOrderDrawerGoodsPageSize = ref(5)
const merchandiseOrderDrawerGoodsTotal = ref(0)
const merchandiseOrderDrawerGoodsKeyword = ref('')
const merchandiseOrderDrawerGoodsName = ref('')
const getMerchandiseOrderDrawerPageInfo = () => ({
  page: merchandiseOrderDrawerPaginationRef.value?.getPage?.() ?? 1,
  pageSize: merchandiseOrderDrawerPaginationRef.value?.getPageSize?.() ?? 20,
})
const flatMerchandiseOrderList = (data = []) => data.reduce((prev, curr) => {
  const orderItems = Array.isArray(curr.orderItems) && curr.orderItems.length > 0
    ? curr.orderItems
    : [{}]
  orderItems.forEach((item) => {
    prev.push({
      ...curr,
      ...item,
      orderId: curr.orderId,
      orderNo: curr.orderNo,
      userId: curr.userId,
      memberId: curr.memberId,
      memberLevelId: curr.memberLevelId,
      levelCode: curr.levelCode,
      nickname: curr.nickname,
      phone: curr.phone,
      orderState: curr.orderState,
      isPartialRefund: curr.isPartialRefund,
      merchandiseOrderMergeKey: `${curr.orderId ?? ''}-${curr.orderNo ?? ''}`,
      paymentTime: curr.paymentTime || curr.orderTime || '',
      receiverName: curr.receiverInfo?.receiverName || '',
      receiverPhone: curr.receiverInfo?.receiverPhone || '',
      receiverAddress: curr.receiverInfo?.receiverAddress || '',
      merchandiseOrderAmount: curr.payableAmount ?? curr.receivedAmount ?? 0,
      merchandiseItemPrice: item.price ?? item.finalPrice ?? 0,
      merchandiseItemState: item.orderItemState || curr.orderState || '',
    })
  })
  return prev
}, [])
const getMerchandiseOrderDrawerSpanArr = (data = []) => {
  const spanArr = []
  let pos = 0
  data.forEach((item, index) => {
    if (index === 0) {
      spanArr.push(1)
      pos = 0
      return
    }
    if (item.merchandiseOrderMergeKey === data[index - 1].merchandiseOrderMergeKey) {
      spanArr[pos] += 1
      spanArr.push(0)
      return
    }
    spanArr.push(1)
    pos = index
  })
  return spanArr
}
const getMerchandiseOrderStateText = (row) => {
  if (row.isPartialRefund) return '已完成（部分退款）'
  return merchandiseOrderEnum.find(item => item.stateId === row.orderState)?.stateName || row.orderState || '--'
}
const getVipLevelText = (levelCode) =>
  vipLevelEnum.find(item => item.stateId === levelCode)?.stateName || levelCode || '--'
const handleGetMerchandiseOrderGoods = async (keyword = merchandiseOrderDrawerGoodsKeyword.value) => {
  try {
    merchandiseOrderDrawerGoodsLoading.value = true
    const res = await listGoodsIgnoreTenant(
      {
        page: merchandiseOrderDrawerGoodsPage.value,
        pageSize: merchandiseOrderDrawerGoodsPageSize.value,
      },
      {
        keyword,
        tenantId: null,
      }
    )
    merchandiseOrderDrawerGoodsKeyword.value = keyword
    merchandiseOrderDrawerGoodsList.value = (res.list || []).map(item => ({
      goodsId: item.goodsId,
      goodsName: item.goodsName,
    }))
    merchandiseOrderDrawerGoodsTotal.value = Number(res.total || 0)
    if (merchandiseOrderDrawerForm.value.goodsId) {
      const currentGoods = merchandiseOrderDrawerGoodsList.value.find(item => item.goodsId === merchandiseOrderDrawerForm.value.goodsId)
      if (currentGoods) merchandiseOrderDrawerGoodsName.value = currentGoods.goodsName
    }
  } catch (e) {
    console.log(e)
  } finally {
    merchandiseOrderDrawerGoodsLoading.value = false
  }
}
const handleSearchMerchandiseOrderGoods = debounceFn(async (keyword = '') => {
  merchandiseOrderDrawerGoodsPage.value = 1
  await handleGetMerchandiseOrderGoods(keyword)
}, 300)
const handleSelectMerchandiseOrderGoods = (goodsId) => {
  const currentGoods = merchandiseOrderDrawerGoodsList.value.find(item => item.goodsId === goodsId)
  merchandiseOrderDrawerGoodsName.value = currentGoods?.goodsName || ''
}
const handleChangeMerchandiseOrderGoodsPage = () => {
  handleGetMerchandiseOrderGoods()
}
const handleMerchandiseOrderGoodsVisibleChange = (visible) => {
  if (!visible) return
  if (!merchandiseOrderDrawerGoodsList.value.length) {
    handleGetMerchandiseOrderGoods()
  }
}
// 查看周边订单
const handleShowMerchandiseOrderDrawer = async (item) => {
  merchandiseOrderDrawer.value = true
  merchandiseOrderDrawerCache.value = item
  await nextTick()
  handleGetMerchandiseOrderGoods()
  handleMerchandiseOrderDrawerSearch('init')
}
// 处理关闭周边订单
const handleCloseMerchandiseOrderDrawer = () => {
  merchandiseOrderDrawer.value = false
  merchandiseOrderDrawerList.value = []
  merchandiseOrderDrawerSpanArr.value = []
  merchandiseOrderDrawerTotal.value = 0
  merchandiseOrderDrawerCache.value = {}
  merchandiseOrderDrawerForm.value = {
    userId: null,
    orderNo: '',
    nickname: '',
    phone: '',
    paymentTimeRange: [],
    paymentStartTime: '',
    paymentEndTime: '',
    goodsId: '',
    orderState: '',
  }
  merchandiseOrderDrawerGoodsList.value = []
  merchandiseOrderDrawerGoodsPage.value = 1
  merchandiseOrderDrawerGoodsTotal.value = 0
  merchandiseOrderDrawerGoodsKeyword.value = ''
  merchandiseOrderDrawerGoodsName.value = ''
  merchandiseOrderDrawerPaginationRef.value?.resetPage?.()
}
// 处理周边订单搜索
const handleMerchandiseOrderDrawerSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') merchandiseOrderDrawerPaginationRef.value?.resetPage?.()
  const paymentTimeRangeCache = Array.isArray(merchandiseOrderDrawerForm.value.paymentTimeRange)
    ? [...merchandiseOrderDrawerForm.value.paymentTimeRange]
    : []
  try {
    merchandiseOrderDrawerLoading.value = true
    const paymentStartTime = paymentTimeRangeCache[0]
      ? moment(paymentTimeRangeCache[0]).format('YYYY-MM-DD HH:mm:ss')
      : null
    const paymentEndTime = paymentTimeRangeCache[1]
      ? moment(paymentTimeRangeCache[1]).format('YYYY-MM-DD HH:mm:ss')
      : null
    merchandiseOrderDrawerForm.value.paymentStartTime = paymentStartTime
    merchandiseOrderDrawerForm.value.paymentEndTime = paymentEndTime
    const requestData = {
      ...merchandiseOrderDrawerForm.value,
      paymentStartTime,
      paymentEndTime,
      goodsId: merchandiseOrderDrawerForm.value.goodsId || null,
      orderState: merchandiseOrderDrawerForm.value.orderState || null,
    }
    delete requestData.paymentTimeRange
    const pageInfo = getMerchandiseOrderDrawerPageInfo()
    const res = await listClubMerchandiseOrder(
      pageInfo,
      merchandiseOrderDrawerCache.value.goodsId,
      requestData
    )
    merchandiseOrderDrawerList.value = flatMerchandiseOrderList(res.list || [])
    merchandiseOrderDrawerSpanArr.value = getMerchandiseOrderDrawerSpanArr(merchandiseOrderDrawerList.value)
    merchandiseOrderDrawerTotal.value = Number(res.total || 0)
  } catch (e) {
    console.log(e)
  } finally {
    merchandiseOrderDrawerForm.value.paymentTimeRange = paymentTimeRangeCache
    merchandiseOrderDrawerLoading.value = false
  }
}
// 处理周边订单重置
const handleMerchandiseOrderDrawerReset = () => {
  merchandiseOrderDrawerFormRef.value?.resetFields?.()
  merchandiseOrderDrawerForm.value.paymentTimeRange = []
  merchandiseOrderDrawerForm.value.paymentStartTime = ''
  merchandiseOrderDrawerForm.value.paymentEndTime = ''
  merchandiseOrderDrawerGoodsPage.value = 1
  merchandiseOrderDrawerGoodsKeyword.value = ''
  merchandiseOrderDrawerGoodsName.value = ''
  handleGetMerchandiseOrderGoods('')
  merchandiseOrderDrawerPaginationRef.value?.resetPage?.()
  handleMerchandiseOrderDrawerSearch('btnSearch')
}
// 处理周边订单下载
const handleMerchandiseOrderDrawerDownload = async () => {
  const paymentTimeRangeCache = Array.isArray(merchandiseOrderDrawerForm.value.paymentTimeRange)
    ? [...merchandiseOrderDrawerForm.value.paymentTimeRange]
    : []
  const paymentStartTime = paymentTimeRangeCache[0]
    ? moment(paymentTimeRangeCache[0]).format('YYYY-MM-DD HH:mm:ss')
    : ''
  const paymentEndTime = paymentTimeRangeCache[1]
    ? moment(paymentTimeRangeCache[1]).format('YYYY-MM-DD HH:mm:ss')
    : ''
  const query = new URLSearchParams({
    userId: merchandiseOrderDrawerForm.value.userId || '',
    orderNo: merchandiseOrderDrawerForm.value.orderNo || '',
    nickname: merchandiseOrderDrawerForm.value.nickname || '',
    phone: merchandiseOrderDrawerForm.value.phone || '',
    paymentStartTime,
    paymentEndTime,
    goodsId: merchandiseOrderDrawerForm.value.goodsId || '',
    orderState: merchandiseOrderDrawerForm.value.orderState || '',
  }).toString()
  merchandiseOrderDrawerForm.value.paymentStartTime = paymentStartTime
  merchandiseOrderDrawerForm.value.paymentEndTime = paymentEndTime
  ElMessage.warning("下载中...")
  await downloadFile(
    `${import.meta.env.VITE_API_URL}/activity/order/admin/downloadMerchandiseOrder/${merchandiseOrderDrawerCache.value.goodsId}?${query}`,
    {},
    `${merchandiseOrderDrawerCache.value.goodsName}周边订单-${moment().format("YYYY-MM-DD_HHmmss")}.csv`
  )
  merchandiseOrderDrawerForm.value.paymentTimeRange = paymentTimeRangeCache
}
// 处理周边订单分页
const handleMerchandiseOrderDrawerChangePage = () => {
  handleMerchandiseOrderDrawerSearch()
}
// 周边订单表格合并单元格
const merchandiseOrderDrawerSpanMethod = ({
  row,
  column,
  rowIndex,
  columnIndex,
}) => {
  if (columnIndex <= 5 || columnIndex > 9) {
    const _row = merchandiseOrderDrawerSpanArr.value[rowIndex] || 1
    const _col = merchandiseOrderDrawerSpanArr.value[rowIndex] > 0 ? 1 : 0
    return [_row, _col]
  }
}

/*修改周边订单状态相关*/
// 修改周边订单状态弹窗
const merchandiseOrderStateDialog = ref(false)
// 修改周边订单状态枚举
const merchandiseOrderStateOption = [
  {
    stateId: "UNPAID",
    stateName: "待付款"
  },
  {
    stateId: "COMPLETED",
    stateName: "已完成"
  },
  {
    stateId: "CANCELLED",
    stateName: "已取消"
  },
  {
    stateId: "REFUNDED",
    stateName: "已退款"
  },
  {
    stateId: "PARTIAL_REFUND",
    stateName: "部分退款"
  },
]
// 周边订单缓存
const merchandiseOrderStateCache = ref({
  orderData: {},
  orderState: ''
})
// 处理周边订单状态
const handleChangeMerchandiseOrderState = async (row) => {
  merchandiseOrderStateDialog.value = true
  merchandiseOrderStateCache.value.orderData = row
}
// 取消修改周边订单状态
const handleCancelMerchandiseOrderState = () => {
  merchandiseOrderStateDialog.value = false
  merchandiseOrderStateCache.value = {
    orderData: {},
    orderState: ''
  }
}
// 确认修改周边订单状态
const handleConfirmMerchandiseOrderState = async () => {
  try {
    let formData = {
      state: merchandiseOrderStateCache.value.orderState,
    }
    await updateMerchandiseOrder(
      merchandiseOrderStateCache.value.orderData.orderId,
      formData,
    )
    ElMessage.success('修改成功')
    handleMerchandiseOrderDrawerSearch()
  } catch (err) {
    console.log(err)
    ElMessage.error('修改失败')
  } finally {
    merchandiseOrderStateDialog.value = false
    merchandiseOrderStateCache.value = {
      orderData: {},
      orderState: ''
    }
  }
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <el-form
        ref="ruleFormRef"
        style="max-width: 400px;text-align: left;"
        :model="formData"
        label-width="auto"
        class="demo-ruleForm"
        status-icon
        label-position="top"
    >
      <div style="gap: 20px;" class="flex">
        <el-form-item label="活动名称：" prop="activityName">
          <el-input style="width: 300px;" v-model="formData.activityName" placeholder="请输入活动名称"></el-input>
        </el-form-item>
        <el-form-item label="活动城市：" prop="city">
          <div style="width: 300px">
            <YTAddress ref="YTAddressRef" :title="'城市'" :onlySecond="true" @select="handleSelectAddress"></YTAddress>
          </div>
        </el-form-item>
        <el-form-item label="活动分组：" prop="groupId">
          <el-select v-model="formData.groupId" placeholder="活动分组" style="width: 300px">
            <el-option
                v-for="item in storeGroupsOption"
                :key="item.storeGroupId"
                :label="item.storeGroupName"
                :value="item.storeGroupId"
            />
          </el-select>
        </el-form-item>
      </div>
      <div style="gap: 20px;" class="flex">
        <el-form-item label="发布时间：" prop="creationTime">
          <el-date-picker
              style="width: 300px"
              v-model="formData.creationTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          />
        </el-form-item>
        <el-form-item label="活动时间：" prop="activityTime">
          <el-date-picker
              style="width: 300px"
              v-model="formData.activityTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          />
        </el-form-item>
        <el-form-item label="活动状态：" prop="activityState">
          <el-select v-model="formData.activityState" placeholder="活动状态" style="width: 300px">
            <el-option
                v-for="item in activityStateOption"
                :key="item.stateId"
                :label="item.stateName"
                :value="item.stateId"
            />
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="11">
        <div class="flex_left mg_b_1">
          <div class="tab_box">
            <div :class="formData.queryType === null ? 'tab_item_active' : 'tab_item'" @click="handleChangeQueryType(null)">全部</div>
            <div :class="formData.queryType === 'BIKING_UP' ? 'tab_item_active' : 'tab_item'" @click="handleChangeQueryType('BIKING_UP')">BIKING UP</div>
            <div :class="formData.queryType === 'NOT_BIKING_UP' ? 'tab_item_active' : 'tab_item'" @click="handleChangeQueryType('NOT_BIKING_UP')">其他商家</div>
          </div>
        </div>
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.goodsName="{item}">
            <el-link type="default" :underline="false" style="text-decoration: underline" :title="item.goodsName" @click="getDetail(item)">
              {{item.goodsName}}
            </el-link>
          </template>

          <template v-slot:item.activityTime="{item}">
            <div>{{ (item.activityInfo.startTime || item.activityInfo.endTime) ? (item.activityInfo.startTime + ' - ' + item.activityInfo.endTime) : '—' }}</div>
          </template>

          <template v-slot:item.city="{item}">
            <div>
              <span v-if="item.activityInfo?.activityType === 'ONLINE' && item.activityInfo?.isNationwide">全国</span>
              <span v-else>{{item.activityInfo.city ?? "—"}}</span>
            </div>
          </template>

          <template v-slot:item.storeName="{item}">
            <div>{{item.tenantName ? `${item.tenantName} - ${item.storeName}` : "—"}}</div>
          </template>

          <template v-slot:item.activityState="{item}">
            {{
              item.activityInfo.activityState
                  ? activityStateOption.find(
                      (i) => i.stateId === item.activityInfo.activityState
                  ).stateName
                  : "—"
            }}
          </template>

          <template v-slot:item.inventory="{item}">
            <div v-if="item.hasDivision">
              {{ item.divisioTotalRegisteredCount }}/{{item.divisionTotalQuotaLimit}}
            </div>
            <div v-else>
              <div v-if="item.inventory">
                {{ item.inventory.lockedQty }}/{{item.inventory.totalQty}}
              </div>
              <div v-else>0</div>
            </div>
          </template>

          <template v-slot:item.retailPrice="{item}">
            <div v-if="item.retailPrice === 0">免费</div>
            <div v-else style="color: #da7a00">
              ￥{{ item.retailPrice }}
            </div>
          </template>

          <template v-slot:item.state="{item}">
            <YTActivityState :state="item.state"></YTActivityState>
          </template>

          <template v-slot:item.storeGroupList="{item, index}">
            <YTTagGroup :list="[item.storeGroup?.storeGroupName ?? '']"></YTTagGroup>
          </template>

          <template v-slot:item.tagList="{item, index}">
            <YTTagGroup :list="item.tagList.map(res => res.tagName)"></YTTagGroup>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-popconfirm @confirm="setSale(item)" :title="`发布“${item.goodsName}”`">
                <template #reference>
                  <div>
                    <el-tooltip
                        v-if="item.state === 0 || item.state === -1"
                        class="box-item"
                        effect="dark"
                        content="发布"
                        placement="left">
                      <v-icon class="cursor-pointer" icon="mdi-tray-arrow-up" color="success"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-tooltip
                  v-if="item.state === 1"
                  class="box-item"
                  effect="dark"
                  content="下架"
                  placement="left">
                <v-icon @click="handleOpenUnSalePanel(item)" class="cursor-pointer" icon="mdi-tray-arrow-down" color="error"></v-icon>
              </el-tooltip>
              <el-popconfirm @confirm="setTop(item, true)" :title="`置顶“${item.goodsName}”`">
                <template #reference>
                  <div>
                    <el-tooltip
                        v-if="!item.activityInfo.isTop"
                        class="box-item"
                        effect="dark"
                        content="置顶"
                        placement="top">
                      <v-icon class="cursor-pointer mg_l_1" icon="mdi-arrow-collapse-up" color="success"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-popconfirm @confirm="setTop(item, false)" :title="`取消置顶“${item.goodsName}”`">
                <template #reference>
                  <div>
                    <el-tooltip
                        v-if="item.activityInfo.isTop"
                        class="box-item"
                        effect="dark"
                        content="取消置顶"
                        placement="top">
                      <v-icon class="cursor-pointer mg_l_1" icon="mdi-arrow-collapse-down" color="success"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="top">
                <v-icon v-show="item.tenantId === '101' || item.assistsOperation" class="mg_l_1" icon="mdi-circle-edit-outline" color="warning" @click="handleToEdit(item)"></v-icon>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="周边订单"
                  placement="right">
                <v-icon v-show="item.tenantId === '101' || item.assistsOperation" class="mg_l_1" icon="mdi-form-select" color="warning" @click="handleShowMerchandiseOrderDrawer(item)"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <el-drawer
      :title="`活动详情${drawerCache.goodsName ? ' - ' + drawerCache.goodsName : ''}`"
      v-model="drawer"
      direction="rtl"
      :close="handleCloseDrawer"
      style="text-align: left"
      :size="'90%'"
  >
    <el-skeleton v-if="drawerLoading" :rows="5" animated />
    <div v-else>
      <el-form-item label="更改报名状态：">
        <el-select v-model="activityState" :disabled="!drawerCache.assistsOperation" placeholder="更改报名状态" style="width: 240px" @change="handleChangeState">
          <el-option
              v-for="item in activityStateOption"
              :key="item.stateId"
              :label="item.stateName"
              :value="item.stateId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="基础信息：">
        <div>
          <div class="flex_left flex_align_t" style="box-sizing: border-box; padding-left: 30px">
            <div class="mg_b_1 form_txt_gray">
              归属商家：{{ drawerCache.tenantName }}——{{ handleOrganizeType(drawerCache.organizeType) }}——{{drawerCache.storeName}}
            </div>
          </div>
          <div class="flex_left flex_align_t" style="box-sizing: border-box; padding-left: 30px">
            <div>
              <div class="mg_b_1 form_txt_gray">
                活动名称：{{ drawerCache.goodsName }}
              </div>
              <div class="mg_b_1 form_txt_gray">
                活动时间：{{
                  drawerCache.activityInfo?.startTime ||
                  drawerCache.activityInfo?.endTime
                      ? drawerCache.activityInfo?.startTime +
                      " - " +
                      drawerCache.activityInfo?.endTime
                      : " - "
                }}
              </div>
            </div>
            <div class="ml150">
              <div class="mg_b_1 form_txt_gray">
                活动类型：
                <span v-if="drawerCache.activityInfo?.activityType === 'ONLINE'">线上</span>
                <span v-else-if="drawerCache.activityInfo?.activityType === 'OFFLINE'">线下</span>
                <span v-else>—</span>
              </div>
              <div class="mg_b_1 form_txt_gray">
                活动城市：
                <span v-if="drawerCache.activityInfo?.isNationwide">
                      全国
                    </span>
                <span v-else>{{ drawerCache.activityInfo?.province
                  }}{{ drawerCache.activityInfo?.city
                  }}{{ drawerCache.activityInfo?.district
                  }}{{ drawerCache.activityInfo?.addressDetail }}</span>
              </div>
            </div>
            <div class="ml150">
              <div class="mg_b_1 form_txt_gray flex_left">
                <div class="mg_r_2">
                  活动分组：{{
                    drawerCache.storeGroup?.storeGroupName
                        ? drawerCache.storeGroup.storeGroupName
                        : "—"
                  }}
                </div>
                <div>
                  活动标签：
                  <span v-if="drawerCache.tagList?.length > 0">
                        <span
                            v-for="(item, index) in drawerCache.tagList"
                            :key="`tagList${index}`"
                        >{{ item.tagName
                          }}<span v-if="index + 1 !== drawerCache.tagList.length"
                          >、</span
                          ></span
                        >
                      </span>
                  <span v-else>—</span>
                </div>
              </div>
              <div class="flex_left" v-if="drawerCache.activityInfo?.activityDivisions.length <= 0">
                <div class="form_txt_gray mg_r_2">
                  骑行距离：{{
                    drawerCache.activityInfo?.cyclingDistance
                        ? drawerCache.activityInfo?.cyclingDistance
                        : 0
                  }}km
                </div>
                <div class="form_txt_gray">
                  骑行速度：{{
                    drawerCache.activityInfo?.cyclingSpeed
                        ? drawerCache.activityInfo?.cyclingSpeed
                        : 0
                  }}km/h
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="报名信息：">
        <div
            style="box-sizing: border-box; padding-left: 30px; display: flex"
        >
          <div>
            <div class="mg_b_1 form_txt_gray">
              报名时间：{{
                drawerCache.activityInfo.applyStartTime ||
                drawerCache.activityInfo.applyEndTime
                    ? drawerCache.activityInfo.applyStartTime +
                    " - " +
                    drawerCache.activityInfo.applyEndTime
                    : " - "
              }}
            </div>
            <div class="mg_b_1 form_txt_gray" v-if="drawerCache.activityInfo.activityDivisions.length <= 0">
              公开范围：{{
                handleVisibilityType(
                    drawerCache.activityInfo.visibilityType
                )
              }}
            </div>
          </div>
          <div class="ml150">
            <div class="mg_b_1 form_txt_gray flex_left">
              <div class="mg_r_2" v-if="drawerCache.activityInfo.activityDivisions.length > 0">
                总报名人数：{{totalLimit}}人（人数上限{{maxLimit}}人）
              </div>
              <div class="mg_r_2" v-else>
                已报名人数：{{
                  drawerCache.inventory?.lockedQty
                      ? drawerCache.inventory?.lockedQty
                      : 0
                }}人（人数上限{{
                  drawerCache.inventory?.totalQty
                      ? drawerCache.inventory?.totalQty
                      : 0
                }}人）
              </div>
              <div class="mg_r_2">待支付{{ drawerCache.unpaidQty }}人</div>
              <div>已取消{{ drawerCache.cancelledQty }}人</div>
              <div class="form_txt_gray mg_l_2" v-if="drawerCache.activityInfo.activityDivisions.length > 0">
                公开范围：{{
                  handleVisibilityType(
                      drawerCache.activityInfo.visibilityType
                  )
                }}
              </div>
            </div>
            <div class="mg_b_1 form_txt_gray" v-if="drawerCache.activityInfo.activityDivisions.length <= 0">
              活动费用：￥{{ Number(drawerCache.retailPrice).toFixed(2) }}
            </div>
          </div>
        </div>
        <div style="box-sizing: border-box" class="mg_b_1 pd_l_3 flex_left flex_align_t" v-if="drawerCache.activityInfo.activityDivisions.length > 0">
          <div class="form_txt_gray">组别信息：</div>
          <div>
            <div class="form_txt_gray flex_left" v-for="(item, index) in drawerCache.activityInfo.activityDivisions" :key="`drawerCache.activityInfo.activityDivisions${index}`">
              <div class="form_txt_gray mg_r_2">{{ item.divisionName }}</div>
              <div class="form_txt_gray mg_r_2">原价￥{{ item.originalPrice }}</div>
              <div class="form_txt_gray mg_r_2">会员价￥{{ item.entryFee }}</div>
              <div class="form_txt_gray mg_r_2">VIP价￥{{ item.vipEntryFee }}</div>
              <div class="form_txt_gray mg_r_2">骑行距离{{ item.distance }}km</div>
              <div class="form_txt_gray mg_r_2">爬升{{ item.elevationGain }}m</div>
              <div class="form_txt_gray mg_r_2">已报名人数{{ item.registeredCount }}人（人数上限{{item.quotaLimit}}人）</div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-divider></el-divider>
      <!-- tabs页面 -->
      <div class="tabs">
        <YTTab :tab_list="tabs_list" @selected="selectTab">
          <template #button_box>
            <div class="flex_right" v-if="tab_selected === 0">
              <v-btn class="mg_r_2" color="success" @click="handleDownloadActivityUser(drawerCache)">下载</v-btn>
              <v-btn color="success" @click="handleDownloadSignedUpActivityUser(drawerCache)">下载已报名人员表</v-btn>
            </div>
            <div class="button_box" v-if="tab_selected === 2">
              <v-btn
                  style="margin-right: 15px; margin-left: 40px"
                  color="#d7d7df"
                  @click="startAlbumEdit"
                  v-if="!img_edit"
              >
                管理
              </v-btn>
              <v-btn
                  color="#d7d7df"
                  @click="cancel_finishAlbum"
                  v-if="img_edit"
              >
                取消
              </v-btn>
              <v-btn
                  class="ml10"
                  color="#4CAF50"
                  @click="finishAlbum"
                  v-if="img_edit"
              >
                保存
              </v-btn>
            </div>
          </template>
        </YTTab>
        <div class="tabs_page mt36 pb300">
          <div v-show="tab_selected === 0">
            <div>
              <el-table
                  id="drawerTable"
                  :data="drawerTableData"
                  :border="false"
                  style="width: 100%; margin-bottom: 24px"
                  height="460"
                  :header-row-style="{ color: '#272539' }"
                  :row-style="{ color: '#656565' }"
                  v-loading="loading"
                  stripe
              >
                <el-table-column label="序号" sortable width="100">
                  <template #header>
                    <span style="padding-left: 13px">序号</span>
                  </template>
                  <template #default="scope">
                    <span style="padding-left: 20px">{{
                        scope.$index + 1
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="hasCheckIn" label="是否签到">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{ scope.row.hasCheckIn ? "是" : "否" }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="nickname" label="用户昵称">
                  <template #default="scope">
                    {{ scope.row.nickname ? scope.row.nickname : "—" }}
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.name" label="姓名">
                  <template #default="scope">
                    {{
                      scope.row.personInfo.name
                          ? scope.row.personInfo.name
                          : "—"
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.gender" label="性别">
                  <template #default="scope">
                    <YTGender :gender="scope.row.personInfo.gender"></YTGender>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="personInfo.phone"
                    label="联系电话"
                    width="120"
                >
                  <template #default="scope">
                    {{
                      scope.row.personInfo.phone
                          ? scope.row.personInfo.phone
                          : "—"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                    prop="personInfo.activityDivisions"
                    label="报名分组"
                    width="120"
                >
                  <template #default="scope">
                    <div v-if="scope.row.activityDivisions.length > 0">
                      <div v-for="(item, index) in scope.row.activityDivisions" :key="`scope.row.activityDivisions${index}`">
                        {{item.divisionName}}
                      </div>
                    </div>
                    <div v-else>
                      —
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="crTime"
                    label="报名时间"
                    sortable
                    min-width="200"
                >
                  <template #default="scope">
                    {{ scope.row.orderTime ? scope.row.orderTime : "—" }}
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.grade" label="年级" v-if="drawerCache.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.grade ? scope.row.personInfo.grade : "—"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.height" width="100" label="身高(cm)" v-if="drawerCache.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.height ? scope.row.personInfo.height : "—"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.weight" label="体重(kg)" v-if="drawerCache.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.weight ? scope.row.personInfo.weight : "—"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="personInfo.certificateType"
                    label="证件类型"
                >
                  <template #default="scope">
                    {{
                      certificateType.find(
                          (i) =>
                              i.stateId === scope.row.personInfo.certificateType
                      )
                          ? certificateType.find(
                              (i) =>
                                  i.stateId === scope.row.personInfo.certificateType
                          ).stateName
                          : "—"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                    prop="personInfo.certificateNumber"
                    label="证件号码"
                    width="180"
                />
                <el-table-column
                    prop="personInfo.emergencyContact"
                    label="紧急联系人"
                    min-width="150"
                />
                <el-table-column
                    prop="personInfo.emergencyContactPhone"
                    label="紧急联系人电话"
                    min-width="130"
                />
                <el-table-column prop="personInfo.mediaPlatformAccount" label="新媒体平台（账号ID）" min-width="180">
                  <template #default="scope">
                    {{ scope.row.personInfo.mediaPlatformAccount ? scope.row.personInfo.mediaPlatformAccount : "—" }}
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.emergencyContactRelation" label="与报名人关系" v-if="drawerCache.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.emergencyContactRelation ? scope.row.personInfo.emergencyContactRelation : "—"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.allergies" label="过敏" v-if="drawerCache.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.allergies ? scope.row.personInfo.allergies : "—"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.hasChildPromise" label="童军承诺" v-if="drawerCache.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.hasChildPromise ? "是" : "否"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.accommodationType" label="住宿登记" v-if="drawerCache.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      <div v-if="scope.row.personInfo.accommodationType === 'NOT_STAYING'">不留宿</div>
                      <div v-else-if="scope.row.personInfo.accommodationType === 'CAMPING'">露营</div>
                      <div v-else-if="scope.row.personInfo.accommodationType === 'HOTEL'">民宿或酒店</div>
                      <div v-else>—</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="receiverInfo.receiverName" label="收货人">
                  <template #default="scope">
                    <div v-if="scope.row.receiverInfo?.receiverName">
                      {{scope.row.receiverInfo?.receiverName}}
                    </div>
                    <div v-else>
                      —
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="receiverInfo.receiverPhone" label="收货电话">
                  <template #default="scope">
                    <div v-if="scope.row.receiverInfo?.receiverPhone">
                      {{scope.row.receiverInfo?.receiverPhone}}
                    </div>
                    <div v-else>
                      —
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="receiverInfo.receiverAddress" label="收货地址">
                  <template #default="scope">
                    <div v-if="scope.row.receiverInfo?.receiverAddress">
                      {{scope.row.receiverInfo?.receiverAddress}}
                    </div>
                    <div v-else>
                      —
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注">
                  <template #default="scope">
                    {{ scope.row.remark ? scope.row.remark : "—" }}
                  </template>
                </el-table-column>
                <el-table-column label="报名状态" width="120" fixed="right">
                  <template #header>
                    <el-popover
                        placement="bottom"
                        :width="200"
                        trigger="click"
                        append-to="#drawerTable"
                    >
                      <template #reference>
                        <div id="header_state">
                          <div class="flex">
                            <div style="margin-right: 15px">报名状态</div>
                            <img
                                class="cursor-pointer"
                                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/select-arrowDown.svg"
                            />
                          </div>
                        </div>
                      </template>
                      <template #default>
                        <div class="select_box">
                          <div
                              class="select_opt txt_overflow flex_bt"
                              v-for="(item, index) in activityState"
                              :key="`activityState${index}`"
                              @click="handleSelectSignStateFilter(item)"
                          >
                            <div
                                :class="
                                selectedIds.includes(item.stateId)
                                  ? 'select_active'
                                  : ''
                              "
                            >
                              {{ item.stateName }}
                            </div>
                            <img
                                v-if="selectedIds.includes(item.stateId)"
                                style="width: 13px; height: 13px"
                                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/selected.svg"
                            />
                          </div>
                        </div>
                      </template>
                    </el-popover>
                  </template>
                  <template #default="scope">
                    <YTActivitySignOrderState
                        v-if="!drawerLoading"
                        class="mg_r_2"
                        :state="scope.row.orderState"
                    ></YTActivitySignOrderState>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pd_b_3" style="padding-right: 20px">
              <YTTablePagination
                  ref="YTTablePaginationDrawerRef"
                  :pageSize="$globalPageSize"
                  :total="totalDrawer"
                  @page-change="handleDrawerPageChange"
              ></YTTablePagination>
            </div>
          </div>
          <div class="ml56" v-show="tab_selected === 1">
            <div class="flex_left flex_align_t">
              <div style="margin-right: 33px">
                <div class="mg_b_1 form_txt_gray">活动封面图：</div>
                <div>
                  <el-image
                      style="width: 140px; height: 140px; border-radius: 15px"
                      :src="drawerCache.images[0]"
                      :zoom-rate="1.2"
                      :max-scale="7"
                      :min-scale="0.2"
                      :preview-src-list="drawerCache.images"
                      show-progress
                      fit="cover"
                  >
                    <template #error>
                      <div class="image-slot">
                        <img
                            style="width: 140px; height: 140px"
                            src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/img_loading_error.svg"
                        />
                      </div>
                    </template>
                  </el-image>
                </div>
              </div>
              <div style="flex: 1">
                <div class="mg_b_1 form_txt_gray">活动描述：</div>
                <div
                    class="ql-editor description_box"
                    v-html="drawerCache.description"
                ></div>
              </div>
            </div>
          </div>
          <div
              class="ml56 pt10"
              v-show="tab_selected === 2"
              v-loading="album_loading"
          >
            <div class="view_statistics fwb">
              相册浏览量：{{ drawerCache?.viewStat?.totalPv }}
            </div>
            <div class="img_box mt20">
              <div class="img_upload_info">
                <BoxUpload
                    :limit="1500"
                    :fileSize="20"
                    :prePath="'album/'"
                    :baseUrl="'/upload/uploadImgs'"
                    :isReplaceMode="false"
                    :showFileList="false"
                    :cache_type="false"
                    @success="handlePicSuccess"
                    @progress="handlePicProgress"
                    @fail="handlePicFail"
                    @remove="handlePicFail"
                ></BoxUpload>
              </div>
              <div class="img_list ml20">
                <div
                    class="img_item ml20 mb20"
                    v-for="(item, index) in img_edit ? albumDraft : album_list"
                    :key="item"
                    @click="showPreview(item)"
                >
                  <div style="position: relative">
                    <img
                        v-if="img_edit"
                        class="del"
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/club/img_del.svg"
                        alt=""
                        @click.stop="deleteAlbumImage(item)"
                    />
                    <img
                        class="image"
                        :src="item.thumbnailAlbumImage_20"
                        alt=""
                    />
                    <img
                        v-if="!getAlbumImageInfo(item).isClubCollected"
                        class="collect"
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/collect.svg"
                        alt=""
                        @click.stop="collectAlbum(item)"
                    />
                    <img
                        v-if="getAlbumImageInfo(item).isClubCollected"
                        class="collected"
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/collected.svg"
                        alt=""
                        @click.stop="showCCDialog(item)"
                    />
                  </div>
                  <div class="collect_count">
                    {{ shortNumberFormat(item.collectionCount) }}人点赞
                  </div>
                </div>
              </div>
            </div>
            <!-- 分页组件 -->
            <YTTablePagination
                v-if="album_total > 0"
                ref="albumPaginationRef"
                :pageSize="album_params.page_params.pageSize"
                :total="album_total"
                @page-change="handleAlbumPageChange"
            />
            <el-dialog v-model="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="Preview Image" />
            </el-dialog>
          </div>
        </div>
      </div>
      <!-- 取消收藏二次确认弹窗 -->
      <YTDialog
          :open="cancel_collect_show"
          text="确认要取消收藏吗？"
          title="取消收藏"
          @confirm="cancelCollectAlbum"
          @cancel="cancel_collect_show = false"
      ></YTDialog>
    </div>
  </el-drawer>

  <!-- 周边订单列表 -->
  <el-drawer
    :title="`周边订单(${merchandiseOrderDrawerCache.goodsName})`"
    v-model="merchandiseOrderDrawer"
    direction="rtl"
    :close="handleCloseMerchandiseOrderDrawer"
    :show-close="false"
    style="text-align: left"
    :size="'90%'"
    stripe
  >
    <template #header="{ close, titleId, titleClass }">
      <div class="flex_left">
        <v-btn
          class="mg_l_1"
          style="margin-right: 7px"
          variant="text"
          icon=""
          @click="handleCloseMerchandiseOrderDrawer"
        >
          <template v-slot:default>
            <el-icon size="20" class="cursor-pointer"><Close /></el-icon>
          </template>
        </v-btn>
        <div :id="titleId" :class="titleClass">
          周边订单{{
            merchandiseOrderDrawerCache.goodsName ? "（" + merchandiseOrderDrawerCache.goodsName + "）" : ""
          }}
        </div>
      </div>
    </template>

    <el-form
      ref="merchandiseOrderDrawerFormRef"
      :model="merchandiseOrderDrawerForm"
      label-width="auto"
      class="demo-ruleForm"
      status-icon
      label-position="top"
    >
      <div class="flex_center flex_left" style="gap: 20px;">
        <el-form-item label="平台订单号：" prop="orderNo">
          <el-input style="width: 300px;" v-model="merchandiseOrderDrawerForm.orderNo" placeholder="请输入平台订单号"></el-input>
        </el-form-item>
        <el-form-item label="用户ID：" prop="userId">
          <el-input style="width: 300px;" v-model="merchandiseOrderDrawerForm.userId" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称：" prop="nickname">
          <el-input style="width: 300px;" v-model="merchandiseOrderDrawerForm.nickname" placeholder="请输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input style="width: 300px;" v-model="merchandiseOrderDrawerForm.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
      </div>
      <div class="flex_center flex_left" style="gap: 20px;">
        <el-form-item label="商品名称：" prop="goodsId">
          <el-select
            style="width: 300px;"
            v-model="merchandiseOrderDrawerForm.goodsId"
            filterable
            remote
            clearable
            reserve-keyword
            remote-show-suffix
            placeholder="请输入商品名称搜索"
            :remote-method="handleSearchMerchandiseOrderGoods"
            :loading="merchandiseOrderDrawerGoodsLoading"
            @change="handleSelectMerchandiseOrderGoods"
            @visible-change="handleMerchandiseOrderGoodsVisibleChange"
          >
            <el-option
              v-for="item in merchandiseOrderDrawerGoodsList"
              :key="item.goodsId"
              :label="item.goodsName"
              :value="item.goodsId"
            ></el-option>
            <template
              v-if="
                !merchandiseOrderDrawerGoodsLoading &&
                merchandiseOrderDrawerForm.goodsId &&
                !merchandiseOrderDrawerGoodsList.some(item => item.goodsId === merchandiseOrderDrawerForm.goodsId)
              "
              #header
            >
              当前已选：
              <el-option
                :label="merchandiseOrderDrawerGoodsName"
                :value="merchandiseOrderDrawerForm.goodsId"
              />
            </template>
            <template #footer>
              <div class="flex_center">
                <el-pagination
                  size="small"
                  background
                  layout="prev, pager, next"
                  :total="merchandiseOrderDrawerGoodsTotal"
                  v-model:current-page="merchandiseOrderDrawerGoodsPage"
                  v-model:page-size="merchandiseOrderDrawerGoodsPageSize"
                  @current-change="handleChangeMerchandiseOrderGoodsPage"
                />
              </div>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="支付时间：" prop="paymentTimeRange">
          <el-date-picker
            style="width: 300px;"
            v-model="merchandiseOrderDrawerForm.paymentTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="订单状态：" prop="orderState">
          <el-select style="width: 300px;" v-model="merchandiseOrderDrawerForm.orderState" clearable placeholder="请选择订单状态">
            <el-option
              v-for="item in merchandiseOrderEnum"
              :key="item.stateId"
              :label="item.stateName"
              :value="item.stateId"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <!-- <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleMerchandiseOrderDrawerSearch('btnSearch')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleMerchandiseOrderDrawerReset">重置</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleMerchandiseOrderDrawerDownload">下载</v-btn>
        </v-col>
      </v-row>
    </v-col> -->
    <div class="flex_left mg_b_3" style="gap: 20px;">
      <v-btn color="success" size="large" @click="handleMerchandiseOrderDrawerSearch('btnSearch')">搜索</v-btn>
      <v-btn size="large" @click="handleMerchandiseOrderDrawerReset">重置</v-btn>
      <v-btn color="success" class="mg_l_3" size="large" @click="handleMerchandiseOrderDrawerDownload">下载</v-btn>
    </div>
    <el-table
      class="merchandise-order-table"
      :data="merchandiseOrderDrawerList"
      :loading="merchandiseOrderDrawerLoading"
      :span-method="merchandiseOrderDrawerSpanMethod"
      style="width: 100%"
    >
      <el-table-column prop="orderNo" label="平台订单号" width="180"></el-table-column>
      <el-table-column prop="paymentTime" label="支付时间" width="180"></el-table-column>
      <el-table-column prop="userId" label="用户ID" width="180"></el-table-column>
      <el-table-column prop="levelCode" label="会员等级">
        <template #default="scope">
          {{ getVipLevelText(scope.row.levelCode) }}
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称"></el-table-column>
      <el-table-column prop="phone" label="联系电话" width="120"></el-table-column>
      <el-table-column prop="goodsName" label="商品名称" min-width="180"></el-table-column>
      <el-table-column prop="quantity" label="数量" width="100"></el-table-column>
      <el-table-column prop="merchandiseItemPrice" label="单价" width="120"></el-table-column>
      <el-table-column prop="merchandiseItemState" label="支付状态" width="120">
        <template #default="scope">
          <YTOrderState :state="scope.row.merchandiseItemState"></YTOrderState>
        </template>
      </el-table-column>
      <el-table-column prop="merchandiseOrderAmount" label="订单金额" width="120"></el-table-column>
      <el-table-column prop="receiverName" label="收货人" width="120"></el-table-column>
      <el-table-column prop="receiverPhone" label="收货电话" width="140"></el-table-column>
      <el-table-column prop="receiverAddress" label="收货地址" min-width="180"></el-table-column>
      <el-table-column prop="orderState" label="订单状态" fixed="right" width="140">
        <template #default="scope">
          <span>{{ merchandiseOrderEnum.find(item => item.stateId === scope.row.orderState)?.stateName }}</span>
          <span @click="handleChangeMerchandiseOrderState(scope.row)" class="mg_l_1" style="cursor: pointer;"><v-icon icon="mdi-pencil"></v-icon></span>
        </template>
      </el-table-column>
    </el-table>
    <template v-slot:bottom>
      <YTTablePagination
        ref="merchandiseOrderDrawerPaginationRef"
        :total="merchandiseOrderDrawerTotal"
        :pageSize="$globalPageSize"
        @page-change="handleMerchandiseOrderDrawerChangePage"
      ></YTTablePagination>
    </template>
  </el-drawer>

  <el-dialog
      v-model="open"
      title="下架活动"
      width="500"
      :before-close="handleClosePanel"
      :show-close="false"
  >
    <div class="flex_center flex_left mg_b_2" @click="unSaleType = 0">
      <div style="margin-right: 13px">
        <YTRadio
            :show="unSaleType === 0"
        ></YTRadio>
      </div>
      <div style="font-size: 16px" class="tips">
        强制下架，商家平台无法重新上架
      </div>
    </div>
    <div class="flex_center flex_left" @click="unSaleType = 1">
      <div style="margin-right: 13px">
        <YTRadio
            :show="unSaleType === 1"
        ></YTRadio>
      </div>
      <div style="font-size: 16px" class="tips">
        正常下架，商家平台可重新上架
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="open = false">取消</el-button>
        <el-button type="primary" @click="handleUnSaleConfirm">
          确认
        </el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog
      v-model="merchandiseOrderStateDialog"
      title="订单状态"
      width="500"
      :before-close="handleClosePanel"
      :show-close="false"
  >
    <div class="flex_center flex_left mg_b_2" @click="unSaleType = 0">
      {{ `是否确定更改【平台订单号：${merchandiseOrderStateCache.orderData.orderNo}；昵称：${merchandiseOrderStateCache.orderData.nickname}；订单金额：${merchandiseOrderStateCache.orderData.merchandiseOrderAmount}】的订单状态？` }}
    </div>
    <div>
      <el-form-item label="更新状态为" label-position="left">
        <el-select v-model="merchandiseOrderStateCache.orderState" placeholder="请选择">
          <el-option
            v-for="item in merchandiseOrderStateOption"
            :key="item.stateId"
            :label="item.stateName"
            :value="item.stateId"
          ></el-option>
        </el-select>
      </el-form-item>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleCancelMerchandiseOrderState">取消</el-button>
        <el-button type="success" style="color: #FFFFFF;" @click="handleConfirmMerchandiseOrderState">
          确认
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
::marker {
  content: none;
}
.tab_box {
  min-width: 134px;
  height: 37px;
  background: #D7D7DF;
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  color: #222222;
  box-sizing: border-box;
  padding: 5px;
  .tab_item {
    line-height: 30px;
    padding: 0 23px;
    border-radius: 8px;
  }
  .tab_item_active {
    line-height: 30px;
    padding: 0 23px;
    background: #FFFFFF;
    box-shadow: 0px 1px 6px 0px rgba(79,79,79,0.18);
    border-radius: 8px;
  }
}
.description_box {
  width: 100%;
  min-height: 150px;
  background: #ffffff;
  border-radius: 9px;
  border: 1px solid #796cb4;
  box-sizing: border-box;
  padding: 10px;
}
.merchandise-order-table {
  :deep(.el-table__header-wrapper th.el-table-fixed-column--right),
  :deep(.el-table__body-wrapper td.el-table-fixed-column--right) {
    background: #ffffff !important;
  }

  :deep(.el-table__body-wrapper tr:nth-child(2n) td.el-table-fixed-column--right) {
    background: #FFFFFF !important;
  }

  :deep(.el-table__body-wrapper tr:hover > td.el-table-fixed-column--right) {
    background: var(--el-table-row-hover-bg-color) !important;
  }
}
.tabs {
  .tabs_page {
    .view_statistics {
      font-size: 18px;
      color: #213547;
    }
    .img_box {
      display: flex;
      align-items: flex-start;
      .img_upload_info {
      }
      .img_list {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        .img_item_upload {
          border: none !important;
        }
        .img_item {
          position: relative;
          .del {
            width: 30px;
            height: 30px;

            position: absolute;
            top: -10px;
            right: -10px;
          }

          .image {
            width: 100px;
            height: 100px;
            object-fit: cover;
            object-position: center;
            background: #f6f6f6;
            border-radius: 20px;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }
          .collect_count {
            border-radius: 25px;
            color: #213547;
            font-size: 12px;
            text-align: center;
          }
          .collect,
          .collected {
            width: 33px;
            height: 26px;

            position: absolute;
            bottom: 7px;
            right: 1px;
          }
        }
      }
    }
  }
}
</style>
